import { Button } from "antd";
import styled from "styled-components";

export const StyledMenuButton = styled(Button)`
    && {
        width: 20px;
        margin-top: 5px;

        svg {
            font-size: 20px;
        }
    }
`;

export const StyledErrorsWrapper = styled.div`
    color: ${({ theme }) => theme.dangerTypographyColor};
`;
